import { Menu, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { FiAtSign, FiHash, FiSmartphone, FiUser } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "react-query";
import moment from "moment-jalaali";
import Tooltip from "../../ToolTip";
import {
  getUserProfile,
  getUserTokens,
} from "../../../api/methods/Authentication";
import { prefix } from "../../../api/ApiConstants";
import { setFirstName, setLastName, setMobile } from "../../../actions";
import { MdOutlineImageNotSupported } from "react-icons/md";
import { hideAll } from "tippy.js";

const ProfileMenu = () => {
  const dispatch = useDispatch();
  const SetMobile = (mobile) => dispatch(setMobile(mobile));
  const SetFirstName = (firstName) => dispatch(setFirstName(firstName));
  const SetLastName = (lastName) => dispatch(setLastName(lastName));
  const [email, setEmail] = useState("");
  const [userPicture, setUserPicture] = useState(
    <MdOutlineImageNotSupported />
  );

  const me = useMutation(["me"], {
    mutationFn: getUserProfile,
    onSettled: (response) => {
      SetMobile(response?.data?.data?.MobileNumber);
      SetFirstName(response?.data?.data?.FirstName);
      SetLastName(response?.data?.data?.LastName);
      setEmail(response?.data?.data?.Email);
      response?.data?.data?.Picture &&
        setUserPicture(prefix + response?.data?.data?.Picture);
    },
  });

  const getMe = async () => {
    await me.mutateAsync();
  };

  const [info, setInfo] = useState([]);
  const Level = useSelector((state) => state["data"].Level);
  const userTokens = useMutation(["userTokens"], {
    mutationFn: getUserTokens,
    onSettled: (response) => {
      if (response?.data?.success) {
        setInfo(
          response?.data?.data?.Rows[response?.data?.data?.TotalCount - 1]
        );
      }
    },
  });

  const getTokens = async () => {
    await userTokens.mutateAsync();
  };

  useEffect(() => {
    getTokens();
    getMe();
  }, []);

  return (
    <Menu as="div" className="relative inline-block">
      <Tooltip content="اطلاعات کاربری">
        <Menu.Button
          aria-label="اطلاعات کاربری"
          className="inline-flex py-2 justify-center w-full"
        >
          <FiUser className="transform scale-125 outline-none border-none" />
        </Menu.Button>
      </Tooltip>
      <Transition
        afterLeave={() => hideAll()}
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute -left-12 transform min-w-fit whitespace-nowrap mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg border dark:border-borderSolid">
          <div className="p-1 flex flex-col items-stretch justify-center">
            <Menu.Item
              as="div"
              className="flex flex-col py-2 border-b-2 dark:border-b-borderSolid text-title items-center justify-around"
            >
              <p className="my-4 text-center text-lg font-semibold">
                حساب کاربری
              </p>
              <div className="grid grid-cols-3 w-full px-4 place-items-center">
                {me?.data?.data?.data?.Picture ? (
                  <img
                    src={`${userPicture}`}
                    alt="UserImage"
                    className="w-16 h-16 rounded-md"
                  />
                ) : (
                  <MdOutlineImageNotSupported size={56} />
                )}
                <h4 className="font-medium col-span-2">
                  {me?.data?.data?.data?.FirstName}{" "}
                  {me?.data?.data?.data?.LastName}
                </h4>
              </div>
            </Menu.Item>
            <Menu.Item
              as="div"
              className="text-title px-4 py-2 text-xs font-semibold"
            >
              <div className="flex flex-wrap items-center gap-1">
                <FiSmartphone size={18} className="text-details" />
                <span className="ml-1 text-details">موبایل:</span>
                {me?.data?.data?.data?.MobileNumber}
              </div>
            </Menu.Item>
            <Menu.Item
              as="div"
              className="text-title px-4 py-2 text-xs font-semibold"
            >
              <div className="flex flex-wrap items-center gap-1">
                <FiAtSign size={20} className="text-details" />
                <span className="ml-1 text-details">ایمیل:</span>
                {email}
              </div>
            </Menu.Item>
            <Menu.Item
              as="div"
              className="text-title px-4 py-2 text-xs font-semibold"
            >
              <div className="flex flex-wrap items-center gap-1">
                <FiHash size={20} className="text-details" />
                <span className="ml-1 text-details">آی پی:</span>
                {info?.IP}
              </div>
            </Menu.Item>
            <Menu.Item
              as="div"
              className="col-span-2 px-4 py-2 text-title text-sm font-semibold text-center"
            >
              <span className="ml-1">آخرین ورود:</span>
              {moment(info?.LastUsed, "YYYY/MM/DD HH:mm:ss").format(
                "jYYYY/jM/jD در ساعت HH:mm:ss"
              )}
            </Menu.Item>
            <Menu.Item
              as="div"
              className="col-span-2 px-4 border-t-2 dark:border-t-borderSolid text-title py-3 mt-1 text-center text-sm font-semibold"
            >
              سطح دسترسی:
              {Level === 2 ? " کارشناس " : Level === 3 ? " ادمین " : " "}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default ProfileMenu;
